const createDiagonalStripes = ({
  stripeColor,
  background,
}: {
  stripeColor: string;
  background: string;
}) =>
  `linear-gradient(45deg, ${stripeColor} 9%, ${background} 9%, ${background} 50%, ${stripeColor} 50%, ${stripeColor} 59%, ${background} 59%, ${background} 100%)`;

export default createDiagonalStripes;
